"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.del = exports.post = exports.patch = exports.put = exports.get = void 0;
const beamCreator_1 = __importDefault(require("./beamCreator"));
//For creating a custom Beam object with tokenBuilder and urlPrefix
exports.default = (0, beamCreator_1.default)(fetch);
//For just using the request functions directly
const BeamClass = (0, beamCreator_1.default)(fetch);
_a = new BeamClass(), exports.get = _a.get, exports.put = _a.put, exports.patch = _a.patch, exports.post = _a.post, exports.del = _a.del;
//# sourceMappingURL=index.js.map